export default "/images/vendor/flag-icon-css/flags/1x1/gb-eng.svg?ebbd69accf16823ad6840bbdfef791ba";